import { useState } from "react";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import CookieConsentBanner from "@/components/CookieConsentBanner";

const Footer = () => {
  const [openConsent, setOpenConsent] = useState(false);
  return (
    <footer className="mt-6 border-t border-gray-100 bg-white" data-testid="app-footer">
      <div className="mx-auto max-w-screen-lg px-4 py-10 sm:px-6">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-2xl font-semibold">Royal</span>
              <span className="font-heading text-2xl font-semibold text-gold-gradient">Lady</span>
            </div>
            <p className="mt-2 text-xs text-gray-500">Timeless silhouettes crafted for the modern woman.</p>
            <div className="mt-3 flex items-center gap-2">
              {[
                { Ic: Instagram, label: "Instagram" },
                { Ic: Facebook, label: "Facebook" },
                { Ic: Twitter, label: "Twitter" },
              ].map(({ Ic, label }, i) => (
                <button
                  key={i}
                  type="button"
                  aria-label={label}
                  className="grid h-8 w-8 place-items-center border border-gray-200 text-gray-600 transition-colors hover:border-black hover:text-black"
                >
                  <Ic className="h-3.5 w-3.5" />
                </button>
              ))}
            </div>
          </div>

          <FooterCol title="Shop">
            <FooterLink to="/category/t-shirts">T-Shirts</FooterLink>
            <FooterLink to="/category/kurtis">Kurtis</FooterLink>
            <FooterLink to="/category/sarees">Sarees</FooterLink>
            <FooterLink to="/category/salwar-suits">Salwar Suits</FooterLink>
            <FooterLink to="/category/office-wear">Office Wear</FooterLink>
            <FooterLink to="/category/jewellery">Jewellery</FooterLink>
            <FooterLink to="/category/beauty">Beauty</FooterLink>
            <FooterLink to="/collection/new">New Arrivals</FooterLink>
            <FooterLink to="/collection/sale">Sale</FooterLink>
          </FooterCol>

          <FooterCol title="Help">
            <FooterLink to="/notifications">Order updates</FooterLink>
            <FooterLink to="/profile">My orders</FooterLink>
            <FooterLink to="/wishlist">Wishlist</FooterLink>
            <FooterLink to="/cart">Bag</FooterLink>
          </FooterCol>

          <FooterCol title="Company">
            <FooterLink to="/about">About us</FooterLink>
            <FooterLink to="/shipping">Shipping</FooterLink>
            <FooterLink to="/returns">Returns</FooterLink>
            <FooterLink to="/terms">Terms &amp; Conditions</FooterLink>
            <FooterLink to="/privacy">Privacy Policy</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
            <button
              type="button"
              onClick={() => setOpenConsent(true)}
              data-testid="footer-cookie-preferences"
              className="text-left text-xs text-gray-500 hover:text-black hover:underline"
            >
              Cookie preferences
            </button>
          </FooterCol>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-gray-100 pt-5 text-[11px] text-gray-500 sm:flex-row">
          <span>© {new Date().getFullYear()} Royal Lady. All rights reserved.</span>
          <span>Crafted in India · Shipped worldwide</span>
        </div>
      </div>
      {openConsent && (
        <CookieConsentBanner
          forceOpen={true}
          onCloseCustomize={() => setOpenConsent(false)}
        />
      )}
    </footer>
  );
};

const FooterCol = ({ title, children }) => (
  <div>
    <div className="mb-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-gray-500">{title}</div>
    <ul className="space-y-2">{children}</ul>
  </div>
);
const FooterLink = ({ to, children }) => (
  <li>
    <Link to={to} className="text-sm text-black hover:text-[#D4AF37]">
      {children}
    </Link>
  </li>
);

export default Footer;
